import type {FC} from "react";

import type {TTabPaneProps} from "./types";
import styles from "./tabPane.module.scss";

const TabPane: FC<TTabPaneProps> = ({children}) => <div className={styles.tabPane}>{children}</div>;

export default TabPane;
